import React, { useEffect, useState } from 'react';
import { Box, Grid, IconButton, InputAdornment, Typography, useMediaQuery } from '@mui/material';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CustomInput, { typeTextField } from '../../../components/UI/CustomInput';
import { msisdnValidation } from '../../../utils/validation';
import { login } from '../../../apis/auth';
import CustomButton from '../../../components/UI/CustomButton';
import bgLogin from '@images/login/knowledge.svg';
import logo from '@images/logo.png';
import { useDispatch } from 'react-redux';
import { toggleAuth } from '../../../store/user/user.reducer';
import { useNavigate } from 'react-router-dom';
import { privateRoutes, publicRoutes } from '../../../configs/routes';
import './login.scss';
import packageJSON from '../../../../package.json';

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [disabled, setDisabled] = useState<boolean>(true);
  const [msisdn, setMsisdn] = useState('');
  const [msisdnError, setMsisdnError] = useState(false);
  const [password, setPassword] = useState('');
  const [type, setType] = useState<typeTextField>('password');
  const [loading, setLoading] = useState<boolean>(false);
  const isMobile = useMediaQuery('(max-width:991px)');

  async function handleSubmit(event: { preventDefault: () => void }) {
    event?.preventDefault();

    setLoading(true);

    const mobileNumber = msisdn.startsWith('0')
      ? `+98${msisdn.slice(1, msisdn.length)}`
      : `+98${msisdn}`;

    try {
      login(mobileNumber, password)
        .then(async (res: any) => {
          if (res?.access_token || res?.accessToken) {
            const userData = res?.userData;

            const user = {
              ...userData,
              token: res?.access_token || res?.accessToken,
            };
            dispatch(toggleAuth(user));
            navigate(privateRoutes.dashboard);
          }
        })
        .catch((e) => console.log({ e }))
        .finally(() => setLoading(false));
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  }

  useEffect(() => {
    if (!msisdnValidation(msisdn) && password !== '') setDisabled(false);
    else setDisabled(true);
  }, [msisdn, password]);

  const FormContent = (
    <form className='form' onSubmit={handleSubmit}>
      <Box className='logo'>
        <img src={logo} alt='' width={140} />
      </Box>

      <Typography color='text.main' fontWeight='bold' fontSize='large' mt={4}>
        ورود به پنل سازمانی
      </Typography>

      <Typography color='text.main' fontSize='small' fontWeight='lighter' mb={3} mt={1}>
        لطفا شماره موبایل و رمز عبور خود را وارد کنید.
      </Typography>

      <CustomInput
        label={msisdn ? 'شماره همراه' : ''}
        placeholder='شماره همراه'
        value={msisdn}
        helperText={msisdnError ? 'شماره همراه اشتباه است.' : ''}
        maxLength={11}
        error={msisdnError}
        inputMode='numeric'
        onChangeHandler={(value) => {
          setMsisdn(value);
          if (msisdnValidation(value) && value !== '') setMsisdnError(true);
          else setMsisdnError(false);
        }}
      />

      <CustomInput
        label={password ? 'رمز عبور' : ''}
        placeholder='رمز عبور'
        value={password}
        type={type}
        onEnter={handleSubmit}
        InputProps={{
          endAdornment: (
            <InputAdornment position='end'>
              {type === 'password' ? (
                <IconButton onClick={() => setType('text')}>
                  <VisibilityOffIcon sx={{ color: '#6A6E73' }} />
                </IconButton>
              ) : (
                <IconButton onClick={() => setType('password')}>
                  <VisibilityIcon sx={{ color: '#6A6E73' }} />
                </IconButton>
              )}
            </InputAdornment>
          ),
        }}
        onChangeHandler={(value) => setPassword(value)}
      />

      <Box className='forgetContainer'>
        <a target='_blank' href='https://talent.bahamtech.com/' rel='noopener noreferrer'>
          <Typography color='secondary.main' fontSize='small' sx={{ textDecoration: 'none' }}>
            ورود به سامانه باهم تلنت
          </Typography>
        </a>

        <Typography
          color='secondary.main'
          fontSize='small'
          onClick={() => navigate(publicRoutes.forgetPassword)}
        >
          فراموشی رمز عبور
        </Typography>
      </Box>

      <Box display='flex' mt={2} gap={1} width='100%'>
        <CustomButton
          fullWidth
          variant='contained'
          disabled={disabled || loading}
          loading={loading}
          type='submit'
        >
          <Typography>ورود</Typography>
        </CustomButton>
      </Box>

      <Box textAlign='center' mt={2} width='100%'>
        <Typography color='primary.main' variant='subtitle2'>
          {`نسخه(v${packageJSON?.version})`}
        </Typography>
      </Box>
    </form>
  );

  const MobileContent = (
    <Box className='mobileContent'>
      <Box>
        <img src={bgLogin} alt='' className='img' />
      </Box>

      <Box className='mainContent'>{FormContent}</Box>
    </Box>
  );

  if (isMobile) return MobileContent;

  return (
    <Grid container className='grid' dir='ltr'>
      <Grid item xl={6} lg={6} md={12} xs={12} className='leftGrid'>
        <img src={bgLogin} alt='' className='img' />
      </Grid>

      <Grid item xl={6} lg={6} md={12} xs={12} dir='rtl' className='rightGrid'>
        {FormContent}
      </Grid>
    </Grid>
  );
};

export default Login;
